import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

type Props = {
    onPress: () => void;
};

const ChildAddCard: React.FC<Props> = ({ onPress }) => {
    return (
        <Pressable onPress={onPress} style={styles.addCard}>
            <View style={styles.addHeroIcon}>
                <MaterialCommunityIcons name="account-plus" size={28} color="#3C8248" />
            </View>
            <Text style={styles.addCardTitle}>Add Family Member</Text>
            <Text style={styles.addCardSubtitle}>Tap to add a family member to your account</Text>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    addCard: {
        width: '100%',
        borderWidth: 1,
        borderColor: '#E0F2E0',
        backgroundColor: '#F9FDF9',
        borderRadius: 16,
        paddingVertical: 24,
        paddingHorizontal: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    addHeroIcon: {
        width: 56,
        height: 56,
        borderRadius: 28,
        backgroundColor: '#E8F5E8',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 12,
    },
    addCardTitle: {
        color: '#111',
        fontWeight: '700',
        fontSize: 16,
        textAlign: 'center',
    },
    addCardSubtitle: {
        marginTop: 8,
        color: '#6B7280',
        fontSize: 13,
        textAlign: 'center',
    },
});

export default ChildAddCard;
